"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapRangeToText = mapRangeToText;

var _isNil = _interopRequireDefault(require("lodash/isNil"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function mapRangeToText(range) {
  var maximum;

  if (range.minimum === range.maximum) {
    maximum = '';
  } else if ((0, _isNil["default"])(range.maximum)) {
    maximum = '-infinity';
  } else {
    maximum = "-".concat(range.maximum);
  }

  var minimum = (0, _isNil["default"])(range.minimum) ? '' : range.minimum;
  return "".concat(minimum).concat(maximum).concat(range.increment ? "#".concat(range.increment) : '');
}